const CookieBannerOptionsRu = {
  text:
    'Мы используем cookies, чтобы улучшить пользовательский опыт посетителей сайта, анализировать трафик, персонализировать контент и запускать рекламу. Оставаясь на сайте, вы соглашаетесь с нашей <a href="https://voximplant.ru/assets/uploads/privacy_policy_ru.pdf" target="_blank">политикой конфиденциальности</a> и с применением нами <a href="https://voximplant.ru/legal/cookies" target="_blank">файлов cookie</a>.',
  translates: {
    back: 'Назад',
    title: '',
    parameters: 'Параметры',
    saveChanges: 'Принять выбранные',
  },
  cookies: [
    {
      name: 'Строго необходимые файлы cookie',
      required: true,
      gtm: 'strict_nec',
      checked: true,
      desc:
        'Эти cookie-файлы необходимы в обязательном порядке для работы нашего сайта. Они позволяют перемещаться по сайту и использовать его функции. Без этих cookie-файлов предоставление услуг, необходимых для использования нашего сайта, таких как доступ к защищенным зонам, невозможно.',
    },
    {
      name: 'Функциональные файлы cookie',
      gtm: 'functionality_cookies',
      checked: true,
      desc:
        'Эти cookie-файлы позволяют нам запоминать ваши предпочтения и адаптировать <a href="https://voximplant.ru/" target="_blank">наш сайт</a> с расширением предоставляемых вам функций и контента. Например, с помощью этих cookie-файлов можно запомнить ваше имя пользователя, выбранный вами язык или страну, внесенные вами изменения в размер текста или шрифта, а также изменения в других частях страниц, которые вы можете настроить под себя.',
    },
    {
      name: 'Аналитические файлы cookie',
      gtm: 'analytics_cookies',
      checked: true,
      desc:
        'Эти cookie-файлы собирают информацию о том, как люди используют наш сайт, в том числе наиболее часто посещаемые страницы, как они переходят с одной ссылки на другую и если посетители получают сообщения об ошибках с определенных страниц. Вся информация, собираемая этими cookie-файлами, группируется на условиях анонимности вместе с информацией об использовании нашего сайта другими людьми. В целом, эти cookie-файлы предоставляют нам аналитическую информацию о том, как работает наш сайт, и как мы можем его улучшить.',
    },
    {
      name: 'Рекламные файлы cookie',
      gtm: 'advertising_cookies',
      checked: true,
      desc:
        'Эти cookie-файлы используются для доставки рекламных объявлений, которые более актуальны для вас и ваших интересов. Они также используются для ограничения количества ваших просмотров рекламы, а также для оценки эффективности рекламной кампании. Эта информация может быть передана другим организациям, например, рекламным партнерам. Это означает, что после того, как вы побываете на нашем сайте, вы можете увидеть некоторые рекламные объявления о наших услугах в другом месте сети Интернет.',
    },
  ],
  buttons: [
    {
      text: 'Принять обязательные',
      type: 'acceptRequired',
      style: 'secondary',
    },
    {
      text: 'Принять',
      type: 'accept',
    },
  ],
};

export default CookieBannerOptionsRu;
